<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="teal" class="white--text" :disabled="selectedItems.length === 0 || statuses.length === 0"
                    v-bind="attrs" v-on="on">
                    {{ $t('changeStatus') }}
                </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="(item, index) in statuses" :key="index" @click="showSnack(item.value)">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-snackbar color="main--black" dark v-model="snackOpen" top>
            <span class="caption pr-4">{{ $t('changeStatus') }}?</span>
            <div>
                <v-btn text class="text--main-yellow" @click="updateStatuses" :disabled="isLoading">{{ $t('yes')
                }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import { CategoriesService } from '../../services'
import { MixinAppSnack } from '../../mixins'

export default {
    name: 'CategoryStatusDropdown',
    mixins: [MixinAppSnack],
    props: {
        selectedItems: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            currentStatus: null,
            statuses: [],
        };
    },
    computed: {},
    methods: {
        fetchStatuses() {
            CategoriesService.getStatuses()
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error('Error fetching statuses:', error);
                });
        },
        showSnack(status) {
            this.currentStatus = status;
            this.openSnack();
        },
        updateStatuses() {
            this.isLoading = true;
            CategoriesService.updateStatus({
                ids: this.selectedItems,
                status: this.currentStatus
            })
                .then(response => {
                    this.closeSnack();
                    this.$emit('update', { type: 'status', data: response.data });
                })
                .catch(error => {
                    this.closeSnack();
                    console.error('Error updating statuses:', error);
                    this.$emit('error', { type: 'status', data: error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    created() {
        CategoriesService.setAuth(this.$store.getters.token)
        this.fetchStatuses();
    },
}
</script>

<style scoped></style>
